import layout from 'app/store/layout';
import { handleErrors } from 'app/store/utils';

const { setLoader, createToast } = layout.actions;

export { setLoader, handleErrors, createToast };
